import styled from "styled-components";

export const Style = styled.div`
  .flex-c {
    display: flex;
    flecx-direction: column;
    justify-content: center;
  }

  .header-cont {
    display: flex;
    margin-bottom: 20px;

    .left {
      flex: 1;

      h4 {
        margin-bottom: 0;
        font-weight: 600;
      }
    }

    .right {
      svg {
        color: var(--color-primary-70);
        font-size: 14px;
      }

      .ant-btn {
        border-color: var(--color-primary-70);
        border-radius: 6px;
      }
    }
  }

  .form {
    display: flex;
    flex-direction: column;
    gap: 14px;

    .ant-btn {
      width: 100%;
    }

    .row-item {
      label {
        font-weight: 500;
      }

      .input {
        display: flex;

        .ant-select {
          flex: 1;
        }
      }

      .list {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .item {
          display: flex;
          gap: var(--size);
          border: 1px solid #EAECF0;
          border-radius: 2px;
          padding: 8px 10px;

          label {
            margin-bottom: 0px;
            font-weight: 500;
            font-size: var(--size);
          }
        }
      }
    }
  }
`;
